import { render, staticRenderFns } from "./link-report.vue?vue&type=template&id=1159af5e&scoped=true&"
import script from "./link-report.vue?vue&type=script&lang=js&"
export * from "./link-report.vue?vue&type=script&lang=js&"
import style0 from "./link-report.vue?vue&type=style&index=0&id=1159af5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1159af5e",
  null
  
)

export default component.exports